import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { OrganizationService } from '../../../services/organization.service';
import { Router } from '@angular/router';
import { UtilityService } from '../../../services/utility.service';
import { AccountService } from '../../../services/account.service';
import { WatchAccountService } from '../../../services/watch-account.service';
import { Subject } from 'rxjs';
import { SubscriptionNotificationService } from '../../../services/subscription-notification.service';

// declare var stripe: any;

@Component({
  selector: 'modal-confirm-subscription',
  template: require('./modal-confirm-subscription.component.pug'),
  styles: [require('./modal-confirm-subscription.component.css').toString()],
})
export class ModalConfirmSubscriptionComponent implements OnInit {
  savings = '0';
  stage = 0;
  billing = 'monthly';
  buttonLabel = '';
  error = '';
  public reason: Subject<any>;

  // Options to pass to the modal:
  plan: string;
  inboxes: number;
  discount: number;
  stripe;

  // -------------------------------------------------------------------
  constructor(
    public bsModalRef: BsModalRef,
    private organization_service: OrganizationService,
    private router: Router,
    private cd: ChangeDetectorRef,
    private utilityService: UtilityService,
    private accountService: AccountService,
    private watch: WatchAccountService,
    private subscriptionNotificationService: SubscriptionNotificationService,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.reason = new Subject();
    let monthly = this.utilityService.getPricing(
      this.plan,
      this.inboxes,
      'monthly',
    );
    let yearly = this.utilityService.getPricing(
      this.plan,
      this.inboxes,
      'yearly',
    );

    if (this.discount) {
      monthly = this.utilityService.getPricingWithDiscount(
        monthly,
        this.discount,
      );
      yearly = this.utilityService.getPricingWithDiscount(
        yearly,
        this.discount,
      );
    }

    this.savings = this.utilityService.toLocaleWithMax2Decimals(
      monthly * 12 - yearly,
    );
  }

  // -------------------------------------------------------------------
  currentPrice(): string {
    let price = this.utilityService.getPricing(
      this.plan,
      this.inboxes,
      this.billing,
    );

    if (this.discount) {
      price = this.utilityService.getPricingWithDiscount(price, this.discount);
    }

    return this.utilityService.toLocaleWithMax2Decimals(price);
  }

  // -------------------------------------------------------------------
  upsell(yearly: boolean) {
    let frequence = 'month';

    if (yearly == true) {
      frequence = 'year';
      this.billing = 'yearly';
    }

    this.buttonLabel =
      'Pay $' + this.currentPrice() + ' now, then every ' + frequence;

    this.stage = 1;
  }

  // -------------------------------------------------------------------
  onCancel() {
    this.bsModalRef.hide();
  }

  // -------------------------------------------------------------------
  buy(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    this.accountService.purchaseSubscription(
      this.watch.accountId().getValue(),
      this.plan,
      this.inboxes,
      this.billing,
      res => {
        if (!res.error) {
          if (!res.stripeConfirmationSecret) {
            this.subscriptionNotificationService.planName.next(this.plan);
            this.cd.detectChanges();
            this.reason.next(true);
            this.bsModalRef.hide();
            return;
          }

          this.stripe
            .handleCardPayment(
              res.stripeConfirmationSecret, // seti_1FNfj8AkNDVprSsPmbRbNJmi_secret_FtSeIo9Te2rKuyY8y03Vg6R1YibMqql
              {
                payment_method: res.stripePaymentMethod, // pm_1FK3FtAkNDVprSsPzSemkTNq
                setup_future_usage: 'off_session',
              },
            )
            .then(result => {
              if (result.error) {
                // Display error.message in your UI.
                this.error = result.error.message;
                onfailure(this.error);
                this.cd.detectChanges();
              } else {
                // The SetupIntent was successful!, ask the server to refresh the subscription status
                this.accountService.refreshSubscription(
                  this.watch.accountId().getValue(),
                  res => {
                    // All good
                    this.subscriptionNotificationService.planName.next(
                      this.plan,
                    );
                    this.cd.detectChanges();
                    this.reason.next(true);
                    this.bsModalRef.hide();
                    return;
                  },
                  error => {
                    console.error(error);
                    // still closing the window as technically, it's all good from our end and we don't want to purchase a second subscription
                    this.reason.next(true);
                    this.bsModalRef.hide();
                    return;
                  },
                );
              }
            });

          return;
        }
        this.error = res.error;
        onfailure(res.error);
      },
      error => {
        onfailure(error);
      },
    );
  }
}
